import { Mail, Phone, MessageSquare } from "lucide-react";
import { useContact, telHref } from "@/lib/contact";
import { Card } from "@/components/portal/ui";

// Portal "Need Help?" area. Keeps the journey portal-first: messaging for sleep/plan questions,
// email for general support, phone as secondary backup for access/scheduling/technical/urgent logistics.
export default function NeedHelp({ showMessaging = true, phonePrimary = false }) {
  const { email, phone } = useContact();
  return (
    <Card className="p-6" data-testid="portal-need-help">
      <div className="eyebrow text-[#9F634E] mb-2">Need help?</div>
      <p className="text-[#6B665E] text-sm leading-relaxed mb-4">
        {showMessaging && "For sleep-plan or Guided Support questions, use your portal messaging. "}
        For account access, scheduling, or technical help, contact us by email or phone.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 [&>a]:min-w-0">
        <a href={`mailto:${email}`} data-testid="help-email"
          className="flex items-center gap-3 rounded-xl border border-[#E5E1D8] px-4 py-3 hover:border-[#9F634E]/40 transition-colors">
          <span className="w-9 h-9 rounded-full grid place-items-center bg-[#F3EFE9] shrink-0"><Mail size={16} className="text-[#9F634E]" /></span>
          <span className="min-w-0"><span className="block text-[11px] text-[#8A998C] uppercase tracking-wide">Email (general support)</span><span className="block text-[#1A1918] text-sm truncate">{email}</span></span>
        </a>
        <a href={telHref(phone)} data-testid="help-phone"
          className="flex items-center gap-3 rounded-xl border border-[#E5E1D8] px-4 py-3 hover:border-[#9F634E]/40 transition-colors">
          <span className="w-9 h-9 rounded-full grid place-items-center bg-[#F3EFE9] shrink-0"><Phone size={16} className="text-[#9F634E]" /></span>
          <span className="min-w-0"><span className="block text-[11px] text-[#8A998C] uppercase tracking-wide">Phone (access & logistics)</span><span className="block text-[#1A1918] text-sm">{phone}</span></span>
        </a>
      </div>
      {showMessaging && (
        <div className="mt-3 flex items-center gap-2 text-xs text-[#8A998C]"><MessageSquare size={13} /> Guided clients: your Certified Infant Sleep Consultant replies fastest in portal messaging.</div>
      )}
    </Card>
  );
}
